<ion-content class="intezmeny-belepo">
  <div class="wrap">
    <div class="fejlec">
      <h1>Válassz intézményt</h1>
      <p>Melyik intézménybe szeretnél belépni?</p>
    </div>

    <div *ngIf="betolt" class="allapot"><ion-spinner name="crescent"></ion-spinner> Betöltés…</div>

    <div *ngIf="!betolt && intezmenyek.length" class="lista">
      <button type="button" class="kartya" *ngFor="let i of intezmenyek" (click)="valaszt(i)">
        <img *ngIf="i.logo" [src]="i.logo" class="ilogo" />
        <span class="szoveg">
          <span class="nev">{{ i.name }}</span>
          <span class="dom">{{ i.baseDomain }}</span>
        </span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>

    <div *ngIf="!betolt && !intezmenyek.length && !hiba" class="allapot">Nincs elérhető intézmény.</div>
    <div *ngIf="hiba" class="hiba">{{ hiba }}</div>

    <div class="kezi">
      <ion-item lines="inset">
        <ion-label position="stacked">Intézmény domain (kézzel)</ion-label>
        <ion-input [(ngModel)]="keziDomain" placeholder="pl. zenit.sulinform.hu" autocapitalize="off" autocorrect="off"></ion-input>
      </ion-item>
      <ion-button expand="block" fill="outline" (click)="valasztKezi()" [disabled]="!keziDomain">
        Belépés ezzel a domainnel
      </ion-button>
      <ion-button expand="block" fill="clear" size="small" (click)="betoltLista()">Lista frissítése</ion-button>
    </div>
    <!-- Lábléc: az akadálymentesítési nyilatkozat (2018. évi LXXV. tv.) és az adatkezelési szabályzat
         (Nkt. 43. § (1)) belépés nélkül is elérhető. -->
    <footer class="lablec">
      <a routerLink="/akadalymentesseg">Akadálymentesítési nyilatkozat</a>
      <span aria-hidden="true"> · </span>
      <a routerLink="/adatkezeles">Adatkezelési szabályzat</a>
    </footer>
  </div>
</ion-content>
